import { Empty, Select, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { showPrice } from '@/utils/utils';

const { Option } = Select;

const options = [2000, 2500, 2700, 3000, 3500, 4000, 4500, 5000, 5500, 6000, 6500, 7000, 7500, 8000, 8500, 9000, 9500];

const ProposalPartnerImportSelect = ({ value, onChange, ...props }) => {
  const { t } = useTranslation('proposalRequest');
  
  const onClearHandler = useCallback(() => {
    onChange && onChange(null);
  }, [onChange]);
  
  const onChangeValueHandler = useCallback((e) => {
    onChange && onChange(e);
  }, [onChange]);
  
  return (
    <Select
      showSearch={false}
      allowClear={true}
      size={'large'}
      {...props}
      notFoundContent={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>}
      value={value}
      onChange={onChangeValueHandler}
      placeholder={t('selectPlaceholder')}
      onClear={onClearHandler}
    >
      <Option key={-1} value={-1} title={t('proposalRequest.form.partners.importBase.other')}>
        <Tooltip title={t('proposalRequest.form.partners.importBase.other')}>
          {t('proposalRequest.form.partners.importBase.other')}
        </Tooltip>
      </Option>
      {options.map((item) => <Option key={item} value={item} title={item} {...item}>
        <Tooltip title={showPrice(item)}>{showPrice(item, '$', '0,0')}</Tooltip>
      </Option>)}
    </Select>
  );
  
};

ProposalPartnerImportSelect.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func
};

ProposalPartnerImportSelect.defaultProps = {};

export default memo(ProposalPartnerImportSelect);
